import type { NuxtApp } from '#app'

export const getCachedDataDefault = (key: string, nuxtApp: NuxtApp) => {
  return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
}
